import { Button } from '@mui/material'
import React from 'react'
import { ServicePage, Title, Desc, Image } from '../../components/service-page'
import { ReactComponent as Error } from './error.svg'
import { useNavigate } from 'react-router-dom'
import { routes } from '../../routes'

const title = '403 Error'
const desc = [
  'Please log in with an authorized account to access this page'
]

const Unauthorized = () => {
  const navigate = useNavigate()

  const handleLogin = () => {
    navigate(routes.login.path)
  }

  return (
    <ServicePage maxContentWidth={1440} inset={3}>
      <Title>{title}</Title>
      <Desc text={desc} />
      <Image imageComponent={Error} />
      <Button variant='contained' onClick={handleLogin} color='primary'>
        Login
      </Button>
    </ServicePage>
  )
}

export default Unauthorized
